import React from 'react';
import Select from '../../../components/ui/Select';

const NotificationFilters = ({ filters, setFilters }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 flex-1">
      <Select
        label="Type"
        value={filters?.type}
        onChange={(e) => setFilters?.({ ...filters, type: e?.target?.value })}
      >
        <option value="">Tous les types</option>
        <option value="quote_request">Demande de Devis</option>
        <option value="milestone_completed">Jalon Complété</option>
        <option value="team_assignment">Assignation Équipe</option>
        <option value="payment_confirmation">Confirmation Paiement</option>
        <option value="inventory_alert">Alerte Stock</option>
        <option value="schedule_reminder">Rappel Mission</option>
        <option value="urgent_alert">Alerte Urgente</option>
      </Select>

      <Select
        label="Priorité"
        value={filters?.priority}
        onChange={(e) => setFilters?.({ ...filters, priority: e?.target?.value })}
      >
        <option value="">Toutes les priorités</option>
        <option value="urgent">Urgent</option>
        <option value="standard">Standard</option>
        <option value="informational">Informationnel</option>
      </Select>

      <Select
        label="Statut"
        value={filters?.status}
        onChange={(e) => setFilters?.({ ...filters, status: e?.target?.value })}
      >
        <option value="">Tous les statuts</option>
        <option value="pending">Non lu</option>
        <option value="read">Lu</option>
        <option value="sent">Envoyé</option>
        <option value="failed">Échec</option>
      </Select>

      <Select
        label="Période"
        value={filters?.dateRange}
        onChange={(e) => setFilters?.({ ...filters, dateRange: e?.target?.value })}
      >
        <option value="all">Toutes les périodes</option>
        <option value="today">Aujourd'hui</option>
        <option value="week">Cette semaine</option>
        <option value="month">Ce mois</option>
      </Select>
    </div>
  );
};

export default NotificationFilters;